import { Component, EventEmitter, forwardRef, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges } from '@angular/core';
import { ControlValueAccessor, FormBuilder, FormGroup, NG_VALUE_ACCESSOR, Validators } from '@angular/forms';
import { Subscription } from 'rxjs/';
import { NextStatusSelectService } from './next-status-select.service';

@Component({
  selector: 'app-next-status-select',
  templateUrl: './next-status-select.component.html',
  styleUrls: ['./next-status-select.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => NextStatusSelectComponent),
      multi: true
    }
  ]
})
export class NextStatusSelectComponent implements OnInit, OnDestroy, ControlValueAccessor, OnChanges {

  @Input() selectedStatus: number;
  @Input() tripNumber: number;
  @Input() onlyForCancel: boolean;
  @Output() statusIdSelected = new EventEmitter<any>();

  arrayStatus = [];
  subscriptions: Subscription = new Subscription();
  selectStatusForm: FormGroup;

  onChangeFn = (_: any) => { };
  onTouchedFn = () => { };

  constructor(private fb: FormBuilder, private nextStatusService: NextStatusSelectService) {
    this.initForm();
  }

  ngOnInit() {
    this.subcriptions();
  }

  subcriptions() {
    this.subscriptions.add(
      this.selectStatusForm.get('statusSelected').valueChanges.subscribe((val) => {
        this.onChangeFn(val);
        this.statusIdSelected.emit(val);
      })
    );

    this.subscriptions.add(
      this.nextStatusService.dataChangeStatu$.subscribe((res) => {
        if (res) {
          this.nextStatusService.getNextStatus(res).subscribe((resp) => {
            this.arrayStatus = resp.map((item) => {
              return { id: item.id, description: item.description };
            });
          });
        }
      })
    );
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['tripNumber'] && this.tripNumber) {
      this.nextStatusService.getStatusByTrip(this.tripNumber).subscribe((tripStatus) => {
        this.arrayStatus = tripStatus;
      });
    }
  }

  initForm() {
    this.selectStatusForm = this.fb.group({
      statusSelected: [null, [Validators.required]]
    });
  }

  writeValue(): void { }

  registerOnChange(fn: any): void {
    this.onChangeFn = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouchedFn = fn;
  }

  setDisabledState(): void { }

  ngOnDestroy() {
    this.subscriptions.unsubscribe();
  }
}



// WEBPACK FOOTER //
// ./src/app/utils/next-status-select/next-status-select.component.ts